<template>
  <fragment>
    <b-form-group horizontal label="Profile Type">
      <span>{{ profileType }}</span>
    </b-form-group>
    <b-form-group
      horizontal
      :invalid-feedback="invalidFeedback.alphaNumeric"
      label="Last name"
    >
      <b-form-input
        type="text"
        v-model="$v.lastName.$model"
        :state="validateState('lastName')"
      />
    </b-form-group>
    <b-form-group
      horizontal
      :invalid-feedback="invalidFeedback.alphaNumeric"
      label="First name"
    >
      <b-form-input
        type="text"
        v-model="$v.firstName.$model"
        :state="validateState('firstName')"
      />
    </b-form-group>
    <b-form-group
      v-if="isMssAdmin"
      horizontal
      :invalid-feedback="invalidFeedback.required"
      label="Society"
    >
      <b-form-select
        v-model="$v.societyId.$model"
        :options="$store.state.societyOptions"
        :state="validateState('societyId')"
      />
    </b-form-group>
  </fragment>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { alphaSpaceValidator } from '@/helpers/customValidators';
import { ROLE_MSS_ADMIN } from '@/helpers/rbacHelper';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'AdminEditForm',
  mixins: [validationMixin],
  props: {
    user: Object,
    role: String,
  },
  data: function () {
    return {
      firstName: (this.user || {}).first_name,
      lastName: (this.user || {}).last_name,
      societyId: (this.user || {}).society_id || null,
    };
  },
  validations: function () {
    const validation = {
      lastName: {
        alphaSpaceValidator,
      },
      firstName: {
        alphaSpaceValidator,
      },
      societyId: {},
    };
    if (this.isMssAdmin) {
      validation.societyId = {
        required,
      };
    }
    return validation;
  },
  computed: {
    invalidFeedback: function () {
      return {
        alphaNumeric: 'Only alpha characters are allowed',
        required: 'This field if required',
      };
    },
    isMssAdmin: function () {
      return this.role === ROLE_MSS_ADMIN;
    },
    profileType: function () {
      return this.isMssAdmin ? 'Society Admin' : 'Phairify Admin';
    },
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    validate: function () {
      this.$v.$touch();
    },
    hasErrors: function () {
      return this.$v.$anyError;
    },
    getData: function () {
      const data = { first_name: this.firstName, last_name: this.lastName };
      if (this.isMssAdmin) {
        data.society_id = this.societyId;
      }
      return data;
    },
  },
};
</script>

<style scoped></style>
